/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Event_Speakers_Remove_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Remove {name}" |
*
* @param {Event_Speakers_Remove_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_speakers_remove_aria_label = /** @type {((inputs: Event_Speakers_Remove_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Speakers_Remove_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Entferne ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Удалить ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Eliminar ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`移除${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を削除`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} को हटाएँ`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Remover ${i?.name}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.name}`)
});